import { render, staticRenderFns } from "./SwiperLayout.vue?vue&type=template&id=2c767249&"
import script from "./SwiperLayout.vue?vue&type=script&lang=js&"
export * from "./SwiperLayout.vue?vue&type=script&lang=js&"
import style0 from "./SwiperLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports